"use client";

import { useEffect, useState } from "react";

let hasInteracted = false;
const listeners = new Set<() => void>();

const interactionEvents = [
  "pointerdown",
  "pointermove",
  "scroll",
  "keydown",
  "touchstart",
] as const;

function notifyInteraction() {
  if (hasInteracted) return;
  hasInteracted = true;
  listeners.forEach((listener) => listener());
  listeners.clear();
}

function subscribe(listener: () => void) {
  if (hasInteracted) {
    listener();
    return () => {};
  }
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useUserInteraction() {
  const [interacted, setInteracted] = useState(hasInteracted);

  useEffect(() => {
    const unsubscribe = subscribe(() => setInteracted(true));
    if (hasInteracted) return unsubscribe;

    const options: AddEventListenerOptions = { passive: true, once: true };
    interactionEvents.forEach((event) => {
      window.addEventListener(event, notifyInteraction, options);
    });

    return () => {
      unsubscribe();
      interactionEvents.forEach((event) => {
        window.removeEventListener(event, notifyInteraction);
      });
    };
  }, []);

  return interacted;
}
